module.exports = __webpack_public_path__ + "../assets/dekstop-5.jpg";